import React, { useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { BiExport } from "react-icons/bi";
import { BsDownload, BsFilter } from "react-icons/bs";
import { CgSortAz } from "react-icons/cg";

const CarbonEmissionHeaderActions = ({
	t,
	onFilterClick,
}) => {

	const ref = useRef();

	const onExport = () => {

	};

	const onFileSelect = (e) => {

	};

	const importFile = (file) => {

	};

	const [isActive, setIsActive] = useState(false);
	const toggleClass = () => {
		setIsActive(!isActive);
	};

	return (
		<div className="header-actions">

			<Button
				onClick={() => {
					toggleClass();
					onFilterClick();
				}}
			>
				<BsFilter />
			</Button>


			<Button variant="headbtn"
				onClick={() => onExport()}
			>
				<BiExport />
			</Button>
			<div>
				<input hidden
					ref={ref}
					type="file"
					id="Browser_input"
					onChange={(e) => onFileSelect(e)}
					onClick={(e) => { e.target.value = null; }}
				/>
				<Button variant="headbtn" onClick={() => ref.current.click()}
					title={t("FileformatText.label")}>
					<BsDownload />
				</Button>
			</div>
		</div>
	);
};

export default withTranslation()(CarbonEmissionHeaderActions);
